'use client'
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'

export default function CombineInfo({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const [mobileModalOpen, setMobileModalOpen] = useState(isOpen)
  const [modalLargeOpen, setModalLargeOpen] = useState(isOpen)

  const isMobile = useBreakpointValue({ base: true, sm: false })

  const handleCloseLargeModal = () => {
    setModalLargeOpen(false)
    onClose()
  }

  const handleCloseMobileModal = () => {
    setMobileModalOpen(false)
    onClose()
  }

  useEffect(() => {
    if (isMobile) {
      setMobileModalOpen(isOpen)
      setModalLargeOpen(false)
    } else {
      setModalLargeOpen(isOpen)
      setMobileModalOpen(false)
    }
  }, [isMobile, isOpen])

  return (
    <>
      <Modal isOpen={modalLargeOpen} onClose={handleCloseLargeModal} isCentered>
        <ModalOverlay />
        <ModalContent mx={18} borderRadius={'16px !important'}>
          <ModalBody p={0} borderTopRadius={28}>
            <Flex className="mb-20 mt-5 flex-col justify-center px-4">
              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Total Earnings
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>

              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the
                <span className="font-bold"> net amount of earnings</span> that
                a user has earned.
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Total Watchtime
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the
                <span className="font-bold"> total amount of time</span> that
                users have spent watching your content on LYKSTAGE.
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Views
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the
                <span className="font-bold"> number of times</span> your content
                has been watched on LYKSTAGE.
              </Text>

              <div className="my-4 flex items-center">
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                  Subscribers
                </span>
                <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
              </div>
              <Text className="text-center text-[16px] text-[#656565]">
                This category shows the total number of users who have
                subscribed to a channel on LYKSTAGE.
              </Text>
            </Flex>

            <Flex className="absolute bottom-[4%] w-full flex-col gap-3 px-4">
              <Button
                className="w-full py-2 font-semibold"
                color={'white'}
                bg={'lyk-green'}
                border="2px solid white"
                _hover={{
                  border: '2px solid white',
                }}
                onClick={handleCloseLargeModal}
              >
                Go Back
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* MOBILE VIEW */}
      <Box>
        <Modal
          isCentered={false}
          onClose={handleCloseMobileModal}
          isOpen={mobileModalOpen}
          motionPreset="slideInBottom"
        >
          <ModalOverlay />
          <ModalContent
            borderTopRadius={28}
            position="fixed"
            pb={84}
            bottom="0"
            margin="0 auto"
            width="100%"
            maxWidth="600px"
            display={{ base: 'block', sm: 'none' }}
          >
            <ModalBody p={0} borderTopRadius={28}>
              <Flex className="mb-2 mt-5 flex-col justify-center px-4">
                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Total Earnings
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>

                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the
                  <span className="font-bold">
                    {' '}
                    net amount of earnings
                  </span>{' '}
                  that a user has earned.
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Total Watchtime
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the
                  <span className="font-bold"> total amount of time</span> that
                  users have spent watching your content on LYKSTAGE.
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Views
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the
                  <span className="font-bold"> number of times</span> your
                  content has been watched on LYKSTAGE.
                </Text>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                    Subscribers
                  </span>
                  <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                </div>
                <Text className="text-center text-[16px] text-[#656565]">
                  This category shows the total number of users who have
                  subscribed to a channel on LYKSTAGE.
                </Text>
              </Flex>

              <Flex className="absolute bottom-[4%] w-full flex-col gap-3 px-4">
                <Button
                  className="w-full py-2 font-semibold"
                  color={'white'}
                  bg={'lyk-green'}
                  border="2px solid white"
                  _hover={{
                    border: '2px solid white',
                  }}
                  onClick={handleCloseMobileModal}
                >
                  Go Back
                </Button>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </>
  )
}
